import { render, staticRenderFns } from "./EquipesForm.vue?vue&type=template&id=29e9d98f&"
import script from "./EquipesForm.vue?vue&type=script&lang=js&"
export * from "./EquipesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports